/**
 * @class SiteOverlay
 * @classdesc An overlay to be placed over the full site content to block interaction
 * with site components while modals are open.
 *
 * @extends Core.Component
 */
export default class SiteOverlay extends Core.Component {
  constructor(el, context) {
    super(el, context);

    this.overlayAnimation = Core.Animations.transition({ el: this.el, state: 'closed' });
    this.events.register(this.el, 'click', () => this.hide());
    this.events.register(window, 'keyup', e => { if (e.key === 'Escape') this.hide(); });
  }

  /**
   * Shows an overlay over the entire site
   */
  show({ belowHeader = false } = {}) {
    if (belowHeader) {
      this.el.style.setProperty('--index-overlay', 'calc(var(--index-header) - 1)');
    } else {
      this.el.style.removeProperty('--index-overlay');
    }

    this.overlayAnimation.animateTo('open');
  }

  /**
   * Hides the overlay
   */
  hide() {
    this.overlayAnimation.animateTo('closed');
  }
}
